import { get } from 'utils/api';

export const getPartnerDashboard = (params = {}) => get('/partner-dashboard', params);

export const partnerDashboardApi = { getPartnerDashboard };
